export default __webpack_public_path__ + "static/media/CurriculumIcon.f2de9c00.svg";